import React, {useState, useContext} from 'react';
import { PostContext } from '../context/PostContext';

const CreatePost= ()=> {
    const [title, setTitle]=useState('');
    const [subtitle, setSubTitle]= useState('');
    const [content, setContent]= useState('');
    const {dispatch}= useContext(PostContext);

    const handleSubmit = (e)=>{
        e.preventDefault();
        const post = {title,subtitle,content};
        dispatch({type: 'CREATE_POST', payload: post});
        setTitle('');
        setSubTitle('');
        setContent('');
    }

    return(
        <div>
            <h2>What's on your mind?</h2>
        <form onSubmit={handleSubmit}>
            <input
            type="text"
            placeholder="Title"
            value={title}
            onChange={(e)=>setTitle(e.target.value)}
            />
            <input
            type="text"
            placeholder="Sub-Title"
            value={subtitle}
            onChange={(e)=>setSubTitle(e.target.value)}
            />
            <textarea
            placeholder="Write anything you want..."
            value={content}
            onChange={(e)=>setContent(e.target.value)}
            />
            <button type="submit">POST</button>
        </form>
        </div>

    );
};

export default CreatePost;